import React from 'react';

import withAppState from '../mobx/withAppState'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faMapMarkedAlt,
  faStar,
  faMapMarkerAlt
} from '@fortawesome/free-solid-svg-icons';

import makeCancelable from '../helpers/PromiseWrapper';

const mapmarker = <FontAwesomeIcon icon={faMapMarkerAlt} />;

const WAIT_INTERVAL = 500;
const LOADING_TIMEOUT_SECONDS = 7;

class RestaurantSearch extends React.Component {
  constructor(props) {
    super(props);
    this.locationSearch = React.createRef();
    this.state = {
      results: this.props.restaurantSearchCache,
      displayingNearby: false,
      nearbyResults: {},
      searchString: '',
      loading: false,
      searching: false,
      resultMessage: 'Use my location',
      favRest:
        !!this.props.customer &&
          !!this.props.customer.favouriteRestaurants
          ? this.props.customer.favouriteRestaurants
          : null
    };
    this.timer = null;
    this.requests = [];
    this.locationRequests = [];
    this.loadingTimeout = null;    
  }

  componentDidMount() {
    if(this.locationHandle) {
      this.handleLocationSearch();
    }
  }

  cancelLocationRequests() {
    for (let i = 0; i < this.locationRequests.length; i++) {
      this.locationRequests[i].cancel();
    }
  }

  componentWillUnmount() {
    for (let i = 0; i < this.requests.length; i++) {
      this.requests[i].cancel();
    }
    this.cancelLocationRequests();
  }

  async handleSearchChange() {
    clearTimeout(this.timer);
    this.timer = setTimeout(
      async () => await this.triggerSearch(),
      WAIT_INTERVAL
    );
  }

  async triggerSearch() {
    let searchInput = document.getElementsByName('search-input')[0];

    if (!!searchInput) {
      const searchString = searchInput.value;
      this.setState({
        searchString
      });
      if (searchString.trim() !== '') {
        this.cancelLocationRequests();

        if (!this.loadingTimeout) {
          this.loadingTimeout = setTimeout(() => {
            this.setState({ loading: true });
          }, LOADING_TIMEOUT_SECONDS * 1000);
        }

        var request = makeCancelable(
          fetch('api/Restaurant/LookupName/' + searchString)
        );
        this.setState({ searching: true });
        this.requests.push(request);
        let response = await request;
        if (response.status === 200) {
          return response
            .json()
            .catch(err => {
              this.loadingTimeout = clearTimeout(this.loadingTimeout);
              this.setState({ loading: false, searching: false });
            })
            .then(data => {
              this.loadingTimeout = clearTimeout(this.loadingTimeout);
              this.setState({
                displayingNearby: false,
                results: data,
                loading: false,
                searching: false
              });
            });
        } else {
          this.loadingTimeout = clearTimeout(this.loadingTimeout);
          this.setState({ loading: false, searching: false });
        }
      } else {
        this.setState({
          displayingNearby: true
        });
      }
    }
  }

  getLocation() {
    navigator.geolocation.getCurrentPosition(
      position => {
        const lat = position.coords.latitude;
        const lng = position.coords.longitude;

          if (!this.loadingTimeout) {
            this.loadingTimeout = setTimeout(() => {
              this.setState({ loading: true });
            }, LOADING_TIMEOUT_SECONDS * 1000);
          }
          this.setState({ searching: true });
        let request = makeCancelable(
          fetch(`api/Restaurant/LookupLatLong/${lat}/${lng}`)
        );
        this.locationRequests.push(request);
        request
          .then(response => {
            if (response.status === 200) {
              response.json().then(data => {
                this.loadingTimeout = clearTimeout(this.loadingTimeout);
                this.setState({
                  nearbyResults: data,
                  displayingNearby: true,
                  loading: false,
                  searching: false
                });
              });
            } else {
              this.loadingTimeout = clearTimeout(this.loadingTimeout);
              this.setState({
                loading: false,
                searching: false
              });
            }
          })
          .catch(err => {
            console.error(err);
            this.loadingTimeout = clearTimeout(this.loadingTimeout);
            this.setState({
              loading: false,
              searching: false
            });
          });
      },
      error => {
        let resultMessage = 'Enable your location to discover nearby restaurants';

        this.setState({
          loading: false,
          searching: false,
          resultMessage
        });

        // console.log(error.code);
        // console.log(error.message);

        // error.code can be:
        //   0: unknown error
        //   1: permission denied
        //   2: position unavailable (error response from location provider)
        //   3: timed out
      }
    );
  } 


  async handleLocationSearch() {
    //  navigator.permissions is not supported on iOS

    if (navigator && navigator.permissions && navigator.permissions.query) {
      let permissionQuery = await navigator.permissions.query({
        name: 'geolocation'
      });
      var navigatorGeolocationState = permissionQuery.state;
      if (navigatorGeolocationState === 'prompt') {
        this.setState({
          resultMessage: 'Would you like to search for nearby restaurants?',
        });
        this.getLocation();
      } else {
        this.getLocation();
      }
    } else {
      this.getLocation();
    }
  }

  handleRestaurantSelect(restaurant) {
    this.props.cacheRestaurantSearch(this.state.results);
    this.props.handleRestaurantSelect(restaurant);
  }

  displayResults() {
    let results = this.state.displayingNearby
      ? this.state.nearbyResults
      : this.state.results;

    if (!!results && !!results.restaurants) {
      var restaurants = results.restaurants;

      if (restaurants.length > 0) {
        var output = [];

        if (this.state.displayingNearby === true) {
          output.push(
            <div
              key={'nearby'}
              className="result-card header"
            >
              <div className="restaurant-address">Nearby</div>
            </div>
          );
        } else {
          output.push(
            <div
              key={'results'}
              className="result-card header"
            >
              <div className="restaurant-address">Search results</div>
            </div>
          );
        }

        output.push(
          restaurants.map((restaurant, index) => {
            return this.restaurantResult(restaurant, index);
          })
        );

        return output;
      }
    }
    return null;
  }

  displayFavourites() {
    if (
      !!this.props.customer &&
      !!this.props.customer.favouriteRestaurants
    ) {
      const favouriteRestaurants = this.props.customer.favouriteRestaurants;
      return (
        <div className="restaurant-favourites">
          <div className="myPeFavourites">
            <h3>My Favourites</h3>
            {favouriteRestaurants.map((restaurant, index) => {
              return this.restaurantResult(restaurant, index);
            })}
          </div>
        </div>
      );
    } else {
      return null;
    }
  }

  restaurantResult(restaurant, index) {
    const { customer } = this.props;
    const starIcon = <FontAwesomeIcon icon={faStar} />;
    let star = null;
    if (customer) {
      const { favouriteRestaurants } = customer;
      const firstFavRestaurantId = (favouriteRestaurants && favouriteRestaurants.length > 0) ? favouriteRestaurants[0].id : null
      if (firstFavRestaurantId === restaurant.id) {
        star = <span className="fav-restaurant-star">{starIcon}</span>;
      }
    }


    let distance = null;
    if (this.state.displayingNearby === true && !!restaurant.distance)
      distance = (Number(restaurant.distance) / 1000).toFixed(1) + 'km';
    return (
      <div
        key={index}
        className="rs-result-card clickable"
        onClick={() => this.handleRestaurantSelect(restaurant)}
      >
        <div className="restaurant-name">
          {`${restaurant.name}`}
          {!!distance && (
            <span className="fav-restaurant-distance">
              &#xa0;-&#xa0;{distance} {mapmarker}
            </span>
          )}
        </div>
        <div className="restaurant-icon">{!!star && star}</div>

        {!!restaurant.fullAddress && (
          <div className="restaurant-address">{restaurant.fullAddress}</div>
        )}
      </div>
    );
  }

  render() {
    const elementMap = <FontAwesomeIcon icon={faMapMarkedAlt} />;
    const resultMessage = this.state.resultMessage;
    return (
      <div ref={this.locationSearch} className="home-card-content">
        <div className="home-card-content-inner">
          <div style={{width: "100%", display: "flex", justifyContent: "center"}}>
            <div className="location-search-container">
            <h3>Enter your postcode or location</h3>
              <div className="preorder-search">
                  <div className="preorder-search-select">
                    <input
                      type="text"
                      autoComplete="off"
                      name="search-input"
                      className="restaurant-search-input"
                      placeholder="Search Location"
                      onKeyDown={async () => await this.handleSearchChange()}
                    ></input>
                  </div>
              <div className="result-card-container">
                {this.displayResults() || (
                  <div className="no-results">
                    <div 
                        className="instruction"
                        onClick={() => this.handleLocationSearch()}
                    >
                      <div
                          className="location-search-button icon"
                        >
                      </div>
                      {resultMessage}
                      </div>
                  </div>
                )}                  
              </div>
            </div>
              

              <div className="loading-text">
                <div
                  className={`lds-dual-ring main-loading ${
                    this.state.searching === true ? '' : 'invisible'
                    }`}
                ></div>
                {this.state.loading === true ? (
                  <p>Sorry, we're taking longer than usual to process your search</p>
                ) : null}
              </div>

              {this.displayFavourites()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withAppState(RestaurantSearch,
  {
    mobXProps: ({
      restaurantSearchCache,
      customer
    }) => ({
      restaurantSearchCache,
      customer
    }),
    mobXActions: ({ 
      cacheRestaurantSearch,
      selectRestaurant,
    }) => ({
      cacheRestaurantSearch,
      selectRestaurant,
    })
  }
);